import { apiSlice } from "app/api/apiSlice"


export const healtPatientsApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['healthPatients','healthProfiles'],
    endpoints: builder => ({
        // Get All
        getHealthPatients: builder.query({
            query: () => {
                return {
                    url: 'health/patients',
                    method: 'GET'
                }
            },
            keepUnusedDataFor: 5,
            providesTags: ['healthPatients']
        }),
        // Get Detail
        getHealthPatientDetail: builder.query({
            query: (userGuid) => {
                return {
                    url: 'health/patient',
                    method: 'GET',
                    params: { userGuid: userGuid }
                }
            },
            keepUnusedDataFor: 5,
            providesTags: ['healthPatients']
        }),
        // Save Patient
        saveHealthPatient: builder.mutation({
            query: ({ payload, userGuid, healthProfileGuid }) => {
                return {
                    url: 'health/patient',
                    method: 'POST',
                    body: payload,
                    params: {
                        userGuid: userGuid,
                        ...(healthProfileGuid && { healthProfileGuid }), // opzionale solo se presente
                    }
                };
            },
            invalidatesTags: ['healthPatients','healthProfiles']
        }),
        // DELETE Patient
        deleteHealthPatient: builder.mutation({
            query: (userGuid) => {
                return {
                    url: 'health/patient',
                    method: 'DELETE',
                    params: { userGuid: userGuid }
                }
            },
            invalidatesTags: ['healthPatients']
        }),
    })
})

export const {
    useGetHealthPatientsQuery,
    useLazyGetHealthPatientDetailQuery,
    useSaveHealthPatientMutation,
    useDeleteHealthPatientMutation
} = healtPatientsApiSlice